import React from "react";
import { Tooltip } from "@themuse/design-system";
import { IndustryIcon } from "components/Icons";

interface IndustriesProps {
    industries: string[];
}

/**
 * Renders the companies industries the associated icon.
 * Additionally renders a tooltip when more than two exist.
 *
 * If there are none does not render.
 */
const Industries = (props: IndustriesProps) => {
    const { industries } = props;
    if (!industries.length) return null;
    const [firstIndustryItem, secondIndustryItem, ...restIndustryList] = industries;
    const firstIndustries = [firstIndustryItem, secondIndustryItem].filter(Boolean).join(", ");
    return (
        <li>
            <IndustryIcon />
            <span>
                {firstIndustries}
                {" "}
                {restIndustryList.length
                    ? (
                        <Tooltip {...{
                            title: "Industries",
                            triggerText: `+ ${restIndustryList.length} more`,
                            content: restIndustryList
                        }}
                        />
                    )
                    : null}
            </span>
        </li>
    );
};
Industries.displayName = "Industries";

export { Industries };
